import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable jsx-a11y/alt-text */
import React, { createRef } from 'react';
import { imageWithPrefix } from '../../scripts/helpers';
import { placeholder } from '../../scripts/media';
var Image = /*#__PURE__*/function (_React$Component) {
  function Image(props) {
    var _this;
    _classCallCheck(this, Image);
    _this = _callSuper(this, Image, [props]);
    _defineProperty(_this, "placeholderRef", void 0);
    _defineProperty(_this, "options", _this.updateOptions());
    if (props.lazyLoading) {
      _this.placeholderRef = createRef();
    }
    return _this;
  }
  _inherits(Image, _React$Component);
  return _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.lazyLoading) {
        this.observe();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src !== this.props.src) {
        this.options = this.updateOptions();
        if (this.props.lazyLoading) {
          this.observe();
        }
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var options = _objectSpread({}, this.props);
      if (options.placeholder) {
        delete options.placeholder;
      }
      options.alt = options.alt || '';
      if (this.props.lazyLoading) {
        options.src = this.props.placeholder || placeholder;
        options['data-src'] = this.props.src;
      } else {
        options.src = imageWithPrefix(this.props.src);
      }
      if (Object.prototype.hasOwnProperty.call(options, 'lazyLoading')) {
        delete options.lazyLoading;
      }
      return options;
    }
  }, {
    key: "observe",
    value: function observe() {
      var _this2 = this;
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('src', imageWithPrefix(_this2.props.src));
            obs.disconnect();
          }
        });
      }, {
        rootMargin: '250px',
        threshold: 0
      });
      observer.observe(this.placeholderRef.current);
      return function () {
        observer.disconnect();
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.lazyLoading ? React.createElement("img", _objectSpread(_objectSpread({}, this.options), {}, {
        ref: this.placeholderRef,
        loading: "lazy"
      })) : React.createElement("img", _objectSpread({}, this.options));
    }
  }]);
}(React.Component);
export { Image as default };